// extracted by mini-css-extract-plugin
export default {"image":"V0-z","loaded":"W0-z"};